export default __webpack_public_path__ + "static/media/free-wifi.2b159a26.svg";